import React from "react";
import "./ConfirmationDialog.css";
import { Button } from "../button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export const ConfirmationDialog = ({
    title,
    message,
    onConfirm,
    onCancel,
    isDanger,
}) => {
    const { t } = useTranslation();
    const primaryButtonColor = isDanger ? "danger" : "primary";

    return (
        <div className="confirmation-overlay" onClick={(e) => { e.stopPropagation(); onCancel(); }}>
            <div className="confirmation-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="confirmation-header">
                    <h3>{title}</h3>
                    <button className="close-button" onClick={onCancel}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="confirmation-content">
                    <p>{message}</p>
                </div>
                <div className="confirmation-actions">
                    <Button
                        text={t('confirmationDialog.cancel')}
                        status="secondary"
                        onClick={onCancel}
                    />
                    <Button
                        text={t('confirmationDialog.confirm')}
                        type={primaryButtonColor}
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </div>
    );
};
